<template>
    <div style="width: 100%; height:  100%;">
        <div style="width: 100%; height:  100%; display: flex; padding: 1.5vh 5vw; justify-content: space-between; align-items: center;" @click="handleIsOpen()">
            <div style="display:flex; align-items: center;">
                <img :src="imgSrc" :style="{width: widthImg, height: heightImg}"/>
                <span style="font-family: Roboto; font-weight: 400; font-size: 14px; color: #1D1D1E; margin-left: 5vw;">
                    {{$t("ItemFilterDocuments."+formattedToChangeLanguage(name))}}
                </span>
            </div>
            <AppIcon :src="is_open?require('@/assets/arrow_drop_down_2.svg'):require('@/assets/arrow_drop_down_3.svg')" :size="29" style="width:7.54px; height: 4.13px" />
        </div>
        <v-divider/>
        <div v-if="is_open && name == 'Nombre'">
            <div style="padding: 1.5vh 5vw;">
                <input
                    v-model="internal_name_in_filter"
                    :placeholder="$t('ItemFilterDocuments.name')+'...'"
                    class="input-name"
                    @input="handlerNameFilter"
                />
            </div>
            <div style="display:flex; flex-wrap: wrap; gap: 0vh 5vw;padding: 0 5vw; padding-bottom: 1.5vh;">
                <button
                    v-for="(order, index) in orders_in_filter" :key="order.id"
                    class="button-az" 
                    @click="handlerOrderInFilter(order.value)" 
                    :style="{
                        border:order.selected? '1px solid black':undefined
                    }"
                >
                    <span>{{order.name}}</span>
                </button>
            </div>
            <v-divider/>
        </div>
        <div v-else-if="is_open && name == 'Tipo'">
            <div style="display:flex; flex-wrap: wrap; gap: 1.5vh 5vw; align-items: center; padding: 1.5vh 7vw; padding-bottom: 1.5vh;">
                <button 
                    v-for="(type, index) in internal_types_in_filter"
                    :key="type.id" class="button-without-space"
                    @click="handlerSelectType(type)"
                    :style="{
                        border:type.selected?'1px solid black':undefined
                    }"
                >
                    <span>
                        {{formattedToChangeLanguage(type.name)? $t('ItemFilterDocuments.'+formattedToChangeLanguage(type.name)): type.name}}
                    </span>
                </button>
            </div>
            <v-divider/>
        </div>
        <div v-else-if="is_open && name == 'Fecha desde'">
            <div style="display:flex; align-items: center; justify-content: center; padding: 1.5vh 7vw;">
                <v-date-picker v-model="internal_date_from" scrollable :locale="$i18n.locale" class="calendar" @change="handlerDateFrom"/>
            </div>
            <v-divider/>
        </div>
        <div v-else-if="is_open && name == 'Fecha hasta'">
            <div style="display:flex; align-items: center; justify-content: center; padding: 1.5vh 7vw;">
                <v-date-picker v-model="internal_date_to" scrollable :locale="$i18n.locale" class="calendar" @change="handlerDateTo"/>
            </div>
            <v-divider/>
        </div>
        <div v-else-if="is_open && name == 'Pendiente de mi aprobación'">
            <div style="display:flex; flex-wrap: wrap; gap: 1.5vh 5vw; align-items: center; padding: 1.5vh 7vw; padding-bottom: 1.5vh;">
                <button 
                    v-for="(pending_approval, index) in internal_pending_approval_in_filter" :key="pending_approval.id"
                    class="button-without-space" 
                    @click="handlerPendingApproval(pending_approval)"
                    :style="{
                        border:pending_approval.selected?'1px solid black':undefined
                    }"
                >
                    <span>{{ formattedToChangeLanguage(pending_approval.name)? $t('ItemFilterDocuments.'+formattedToChangeLanguage(pending_approval.name)): pending_approval.name }}</span>
                </button>
            </div>
            <v-divider/>
        </div>
    </div>
</template>

<script>
import { excelFileChosen } from '@/modules/invoices/domain/Invoice';


export default {
    props: {
        imgSrc:{
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        widthImg: {
            type: Number,
            required: true
        },
        heightImg: {
            type: Number,
            required: true
        },
        name_in_filter: {
            type: String,
            required:false
        },
        orders_in_filter: {
            type: Array,
            required:false
        },
        types_in_filter: {
            type: Array,
            required:false
        },
        date_from_in_filter: {
            type: String,
            required:false
        },
        date_to_in_filter: {
            type: String,
            required:false
        },
        pending_approval_in_filter: {
            type: Array,
            required:false
        }
    },
    data(){
        return {
            is_open: false,
            selected_order: "",
            internal_name_in_filter: this.name_in_filter,
            internal_orders_in_filter: this.orders_in_filter,
            internal_types_in_filter: this.types_in_filter,
            internal_date_from: this.date_from_in_filter,
            internal_date_to: this.date_to_in_filter,
            internal_pending_approval_in_filter: this.pending_approval_in_filter,
        }
    },
    mounted(){
        
    },
    methods: {
        handleIsOpen(){
            this.is_open = !this.is_open
        },
        handlerNameFilter() {
            this.internal_orders_in_filter.forEach((order)=>{
                order.selected = false
            })
            this.$emit("change-name-in-filter", {name: this.internal_name_in_filter, orders: this.internal_orders_in_filter})
        },
        handlerOrderInFilter(value) {
            this.internal_name_in_filter=""
            this.internal_orders_in_filter.forEach((order) => {
                if(order.value == value){
                    order.selected = !order.selected
                }else{
                    order.selected = false
                }
            })
            this.$emit("change-name-in-filter", {name: this.internal_name_in_filter, orders: this.internal_orders_in_filter})
        },
        handlerSelectType(type){
            this.internal_types_in_filter.forEach((t) => {
                if(t.id == type.id){
                    t.selected = !t.selected
                }else{
                    t.selected = false
                }
            })
            this.$emit("change-types-in-filter", this.internal_types_in_filter)
        },
        handlerDateFrom(){
            this.$emit("change-date-from", this.internal_date_from)
        },
        handlerDateTo(){
            this.$emit("change-date-to", this.internal_date_to)
        },
        handlerPendingApproval(pending_approval_selected){
            this.internal_pending_approval_in_filter.forEach((pending_approval) => {
                if(pending_approval.id == pending_approval_selected.id){
                    pending_approval.selected = !pending_approval.selected
                }else{
                    pending_approval.selected = false
                }
            })
            this.$emit("change-pending-approval-in-filter", this.internal_pending_approval_in_filter)
        },
        formattedToChangeLanguage(text){
            switch(text){
                case "Nombre":
                    return "name"
                case "Tipo":
                    return "type"
                case "Fecha desde":
                    return "date_from"
                case "Fecha hasta":
                    return "date_to"
                case "Nómina":
                    return "payroll"
                case "Contrato":
                    return "contract"
                case "Modelos/Impuestos":
                    return "taxes_and_models"
                case "Certificado":
                    return "certificate"
                case "Facturas":
                    return "invoices"
                case "Otros":
                    return "others"
                case "Todos":
                    return "all"
                case "Sí":
                    return "yes"
                case "No":
                    return "no"
                default:
                    return ""
            }
        }
    }
}
</script>

<style scoped>
.input-name{
    padding: 0px 12px;
    border: 1px solid #b0b0b0;
    border-radius: 2px;
    width: 100%;
    outline: none;
}
.input-name:focus{
    border: 1px solid black;
}
.input-name::placeholder {
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
}
.button-az{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 3vw;
    background-color: #f3f3f3;
    border-radius: 32px;
}
.button-az span {
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    color: #1d1d1e;
}
.button-az-selected{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 3vw;
    background-color: #f3f3f3;
    border: 1px solid #1d1d1e;
    border-radius: 32px;
}
.button-az-selected span {
    font-family: Roboto;
    font-weight: 500;
    font-size: 12px;
}
.button-without-space {
    display:flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    background-color: #f4f4f4;
    border-radius: 32px;
}
.button-without-space span {
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    color: #1d1d1e;
    text-align: center;
}
.calendar{
    font-family: Roboto;
}
.calendar >>> .v-picker__title {
    display: none;
}
.calendar >>> .v-date-picker-header.theme--light {
    background-color: #f3f3f3;
    border-bottom: 1px solid #888888;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.calendar >>> .v-date-picker-table.v-date-picker-table--date.theme--light {
    background-color: #f3f3f3;
    height: auto;
}

.calendar >>> .v-btn.v-btn--active {
    background-color: var(--v-primary-base) !important;
    border-color: var(--v-primary-base) !important;
    color: white !important; /* Asegura contraste si usas fondo oscuro */
}

.calendar >>> .v-btn.v-date-picker-table__current {
    border-color: var(--v-primary-base) !important;
    color: var(--v-primary-base) !important;
}

.calendar >>> .v-btn.v-date-picker-table__current.v-btn--active {
    background-color: var(--v-primary-base) !important;
    color: white !important;
}
</style>